import Base from "./base";

export default class TurboYatirim extends Base {
    makeExternalPayment(newStep) {
        const { stake } = this.state;
        this.props.externalFunc.makeDeposit({
            processType: "paybol",
            paymentType: "paybol",
            returnUrl: location.href,
            amount: stake
        }, (data) => {
            this.setState({
                externalUrl: data.url,
                currentStep: newStep
            })
        });
    }

    makeExternalPaymentWithBonus(newStep, bonusId) {
        const { stake } = this.state;
        this.props.externalFunc.makeDeposit({
            processType: "paybol",
            paymentType: "paybol",
            returnUrl: location.href,
            amount: stake,
            claimsBonus: true,
            bonusId: bonusId
        }, (data) => {
            this.setState({
                externalUrl: data.url,
                currentStep: newStep
            })
        });
    }
}
